import { QuotePatchRequestBody, QuoteRequestParams } from '@lio/api-types';
import { formVersionQueryKeys } from '@services/formVersion/keys';
import { quoteFormQueryKeys } from '@services/quoteForm/keys';
import { quoteItemQueryKey } from '@services/quoteItem';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export type UpdateQuoteRequest = QuotePatchRequestBody & QuoteRequestParams;

export const useUpdateQuote = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const mutationFn = (request: UpdateQuoteRequest) => {
    const { quoteId, ...other } = request;

    const url = `quote/${quoteId}`;
    return client.patch(url, {
      json: { ...other },
    });
  };
  const result = useMutation({
    mutationFn,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['quote', { quoteId: variables.quoteId }] });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: quoteItemQueryKey.searchWithParams({ quoteId: variables.quoteId }) });
      queryClient.invalidateQueries({ queryKey: quoteFormQueryKeys.get(variables.quoteId) });
      queryClient.invalidateQueries({ queryKey: formVersionQueryKeys.get(variables.quoteId) });
    },
  });
  return {
    ...result,
    updateQuote: result.mutateAsync,
  };
};
